import {jsx} from 'panel';

import {ProjectFeatureFlag} from 'common/report/constants';
import {Store} from 'common/report/stores/store';
import {ProjectDetails} from 'common/report/stores/project-details';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {DisplayContext} from 'common/widgets/date-range-picker/models/types';
import {QueryBlockEl} from 'common/widgets/query-block';

import {DateRangePresetBarEl} from './index';

// Header date selector shim that chooses between rendering the new prototype and the old <mp-query-block>
export function headerDateSelectorRenderer({
  displayContext,
  selectedDateRange,
  projectAsOfDate,
  maxHistoryDays,
  currentProjectStore,
  projectId,
  tooltipData,
  handleTrack,
  handleApply,
  handleRemove = null,
}: {
  displayContext: DisplayContext;
  selectedDateRange: null | Partial<DateRange>;
  projectAsOfDate: string;
  maxHistoryDays: number;
  currentProjectStore: Store<ProjectDetails>;
  projectId: number;
  tooltipData: any;
  handleTrack: (ev) => void;
  handleApply: (ev) => void;
  handleRemove?: () => void;
}) {
  const showPrototype = currentProjectStore.value?.hasFeatureFlag(ProjectFeatureFlag.NewDatePicker) ?? false;
  if (showPrototype) {
    // TODO: support tooltipData in some form
    return (
      <DateRangePresetBarEl
        attrs={{
          'display-context': displayContext,
          'date-range': JSON.stringify(selectedDateRange ?? null),
          'project-as-of-date': projectAsOfDate,
          'max-history-days': maxHistoryDays,
          'tracked-use-case': `query-builder`,
          'can-clear': !!handleRemove,
        }}
        on={{
          apply: handleApply,
          clear: handleRemove,
        }}
      />
    );
  }

  return (
    <QueryBlockEl
      attrs={{
        type: `time`,
        label: `Select date`,
        'selector-type': `button`,
        'selector-icon': `calendar`,
        elref: `timeMenu`,

        'display-context': displayContext,
        'max-data-history-days': maxHistoryDays,
        selected: JSON.stringify(selectedDateRange ?? null),
        'project-as-of-date': projectAsOfDate,
        'tooltip-data': JSON.stringify(tooltipData),
        'project-id': projectId,
        removable: !!handleRemove && !!selectedDateRange,
      }}
      on={{
        select: (ev: CustomEvent) => {
          // temporary shim to ensure consistency for handleApply before the prototype replaces this query-block
          const dateRange = ev.detail;
          handleApply(new CustomEvent(ev.type, {detail: {dateRange}}));
        },
        remove: handleRemove,
        track: handleTrack,
      }}
    />
  );
}
